module.exports = __webpack_public_path__ + "static/world-map-63d8bea5f879c9dc3d3db6b52e426f34.svg";